import axios from 'axios';
import * as _ from 'lodash';

import config from '../config';
import { headers } from '../utilities'

export const FETCH_PRODUCT_PRICE_LIST = 'FETCH_PRODUCT_PRICE_LIST';
export const FETCH_PRODUCT_PRICE_LIST_FULFILLED = 'FETCH_PRODUCT_PRICE_LIST_FULFILLED';
export const FETCH_PRODUCT_PRICE_LIST_REJECTED = 'FETCH_PRODUCT_PRICE_LIST_REJECTED';

export const fetchProductPriceList = (filters = {}) => dispatch => {
  const params = _.mapValues(Object.assign({}, filters), filter => filter.join ? filter.join(',') : filter)
  dispatch({
    type: FETCH_PRODUCT_PRICE_LIST,
    payload: {}
  });
  return axios.get(`${config.REACT_APP_API_BASE_URL}/distributor-pricelists`, { headers: headers(), params })
    .then(response => {
      dispatch({
        type: FETCH_PRODUCT_PRICE_LIST_FULFILLED,
        payload: response.data
      });
      return response;
    })
    .catch(err => {
      dispatch({
        type: FETCH_PRODUCT_PRICE_LIST_REJECTED,
        payload: err
      });
      return err;
    });
}